module.exports = __webpack_public_path__ + "static/media/design@3x.6e9e8b39.png";